module.exports = __webpack_public_path__ + "static/img/warehouse02.015c4c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warehouse02.jpg
// module id = xHuu
// module chunks = 0